import { defineRecipe } from "@chakra-ui/react";

export const iconRecipe = defineRecipe({
  variants: {
    size: {
      "2xl": {
        boxSize: "12",
      },
      "3xl": {
        boxSize: "16",
      },
    },
  },
});
